module.exports = __webpack_public_path__ + "img/refreshNew.ffe8e8f8.svg";